import React, { useState, useRef, useEffect } from "react";
import styles from "./Style.module.css";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import { connect, useDispatch } from "react-redux";
import { ButtonBase, Input } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";
import EventEmitter from "../../../libs/Events.utils";
import history from "../../../libs/history.utils";
import { actionLoginUser } from "../../../actions/auth_index.action";
import {
  serviceRequestOtp,
  serviceVerifyOTP,
} from "../../../services/index.services";
import historyUtils from "../../../libs/history.utils";

const validate = (values) => {
  const errors = {};
  const requiredFields = ["otp"];

  requiredFields.forEach((field) => {
    if (!values[field]) {
      errors[field] = "Required";
    }
  });
  if (values["otp"] && values["otp"].length > 4) {
    errors["otp"] = "Only 4 digits are allowed";
  }
  if (values["otp"] && values["otp"].length < 4) {
    errors["otp"] = "OTP is of 4 digit";
  }
  return errors;
};

const Otp = ({ contact, country_code, handleSubmit }) => {
  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [disableResend, setDisableResend] = useState(false);
  const [timerCounter, setTimerCounter] = useState(30);
  const [otp, setOtp] = useState([]);
  const [isValid, setIsValid] = useState(false);
  const inputRefs = useRef([]);
  const [errorOtp, setErrorOtp] = useState(false);

  let timeout = null;
  let timerInterval = null;

  const dispatch = useDispatch();

  useEffect(() => {
    for (let x in inputRefs.current) {
      inputRefs.current[x].onkeyup = (e) =>
        _handleKeyPress(e, inputRefs.current[x]);
    }
    inputRefs.current[0].focus();

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const _timeoutDisable = () => {
    timeout = setTimeout(() => {
      clearInterval(timerInterval);
      setDisableResend(false);
      setTimerCounter(30);
    }, 30000);
    timerInterval = setInterval(() => {
      setTimerCounter((prevCounter) => prevCounter - 1);
    }, 1000);
  };

  const _handleKeyPress = (e, field) => {
    if (e.keyCode === 8) {
      const tempNum = parseInt(field.name) - 1;
      if (tempNum >= 0) {
        inputRefs.current[tempNum].focus();
      }
      const temp = [];
      for (let i = 0; i < 4; i++) {
        if (!inputRefs.current[i].value) {
        } else {
          temp[i] = inputRefs.current[i].value;
        }
      }
      setOtp(temp);
      setIsValid(false);
    }
    if (
      (e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105) ||
      e.keyCode === 229
    ) {
      const a = field.value;
      field.value = a.slice(-1);

      const tempNum = parseInt(field.name) + 1;
      if (inputRefs.current.length > tempNum) {
        inputRefs.current[tempNum].focus();
      }
      let isDone = true;
      const temp = [...otp];
      for (let i = 0; i < 4; i++) {
        if (!inputRefs.current[i].value) {
          isDone = false;
        } else {
          temp[i] = inputRefs.current[i].value;
        }
      }
      setOtp(temp);
      setIsValid(isDone);
    }
  };

  useEffect(() => {
    if (errorOtp) {
      setTimeout(() => {
        setErrorOtp(false);
      }, [2000]);
    }
  }, [errorOtp]);

  const handleResendOtp = async () => {
    const countryCode = country_code.toString();
    const lengthData = countryCode?.length;
    const removePlus = countryCode.slice(1, lengthData);
    const cont = removePlus + " " + contact;

    const tempRequest = await serviceRequestOtp({ contact: cont });
    if (!tempRequest.error) {
      setDisableResend(true);
      _timeoutDisable();
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar(false);
  };

  const _handleLoginPassword = () => {
    historyUtils.push("login");
  };

  const _handleSubmit = async (data) => {
    const cont = country_code + " " + contact;
    const tempRequest = await serviceVerifyOTP({
      contact: cont?.replace(/[+-]/g, ""),
      otp: otp.toString().replace(/,/g, ""),
    });

    if (!tempRequest.error) {
      dispatch(actionLoginUser(tempRequest?.data));
      setErrorOtp(false);
    } else {
      EventEmitter.dispatch(EventEmitter.THROW_ERROR, {
        error: "Invalid Credentials! Please verify.",
        type: "error",
      });
      setErrorOtp(true);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit(_handleSubmit)}>
        <div className={styles.loginFormData}>
          <span className={styles.headingText}>OTP Verification</span>
          <div className={styles.newLine} />
        </div>
        <br />
        <br />
        <div className={styles.description}>
          <div className={styles.innerText}>
            We have sent a 4 digit OTP to your registered Mobile Number
            <br />
            <span style={{ fontSize: "16px", marginLeft: "5px" }}>
              {country_code} - {contact}
            </span>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <Input
            className={styles.inputFields}
            type="number"
            name="0"
            inputRef={(el) => (inputRefs.current[0] = el)}
          />
          <Input
            className={styles.inputFields}
            type="number"
            name="1"
            inputRef={(el) => (inputRefs.current[1] = el)}
          />
          <Input
            className={styles.inputFields}
            type="number"
            name="2"
            inputRef={(el) => (inputRefs.current[2] = el)}
          />
          <Input
            className={styles.inputFields}
            type="number"
            name="3"
            inputRef={(el) => (inputRefs.current[3] = el)}
          />
        </div>

        <div className={styles.bottomText}>
          <span className={styles.receive}>Didn't Receive OTP? </span>
          <ButtonBase
            onClick={handleResendOtp}
            type={"button"}
            disabled={disableResend}
            className={styles.resendText}
          >
            Resend OTP
            {disableResend
              ? " - " +
                "00:" +
                (timerCounter >= 10 ? timerCounter : "0" + timerCounter)
              : ""}
          </ButtonBase>
        </div>
        <br />
        <br />
        <div className={"text-center"}>
          {otp?.length === 4 ? (
            <ButtonBase type={"submit"} className={styles.sendOTPBtn}>
              Login
            </ButtonBase>
          ) : (
            <ButtonBase className={styles.sendOTPBtnDisable} disable={true}>
              Login
            </ButtonBase>
          )}
        </div>
        <br/>
        <div className={styles.bottomSignUp}>
          <ButtonBase
            onClick={_handleLoginPassword}
            className={styles.forgotBtn}
          >
            Alternately Login with password{" "}
          </ButtonBase>
        </div>
      </form>
      <Snackbar
        // anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorOtp}
        message={<span id="message-id">{"INVALID OTP"}</span>}
      />
    </div>
  );
};

const temp = reduxForm({
  form: "otp",
  validate,
})(Otp);

const mapStateToProps = (state) => {
  return {
    // contact: state.auth.user_details.contact,
    // country_code: state.auth.user_details.country_code,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      // actionLoginUser: actionLoginUser,
      // actionSetActive: actionSetActive,
      // actionStoreUserData: actionStoreUserData,
      actionLoginUser: actionLoginUser,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(temp);
